import {HttpClient} from '@angular/common/http';
import {Component, effect} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {AuthenticationService} from '@authentication/authentication.service';
import {OrgService} from '@services/organization/org.service';
import {lastValueFrom} from 'rxjs';

export interface LoginService {
  id: string;
  name: string;
  image: string;
  websiteURL?: string;
  hasLandingService: boolean;
  allowPublishDatasets?: boolean;
}

@Component({
  selector: 'app-login',
  imports: [MatButton, MatIconModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  loginServices: LoginService[];

  constructor(
    readonly metaOrgService: OrgService,
    protected readonly authService: AuthenticationService,
    readonly http: HttpClient,
  ) {
    effect(() => {
      const orgs = this.metaOrgService.organizationArray();
      let sortedOrgsWithEntityID = orgs.filter(org => org.entity_id);
      this.loginServices = sortedOrgsWithEntityID
        .map(org => {
          return {
            id: org.entity_id,
            name: org.full_name,
            image: <string>org.config_data['login_tile_logo'], // nosonar - cast to string is required
            hasLandingService: !!org.data_enclave_url,
            allowPublishDatasets: false, //todo: get value from the organization metadata service.
            displayOrder: <number>org.config_data['display_order'], // nosonar - cast to number is required
          };
        })
        .sort((a, b) => a.displayOrder - b.displayOrder);
    });
  }
  async getBackupImage($event: ErrorEvent, idp: string) {
    // If the login tile logo doesn't work properly, get it from InCommon as a last resort.
    const img = $event.target as HTMLImageElement;
    if (img.dataset['inCommon']) {
      if (img.src != img.dataset['inCommon']) {
        img.src = img.dataset['inCommon'];
      }
      return;
    }
    img.dataset['inCommon'] = 'about:blank';
    const mdqRaw = await lastValueFrom(
      this.http.get('https://mdq.incommon.org/entities/' + encodeURIComponent(idp), {responseType: 'text'}),
    );
    const mdq = new DOMParser().parseFromString(mdqRaw, 'text/xml');
    const mdqLogoElem = mdq.evaluate(
      '//mdui:Logo',
      mdq,
      prefix => (prefix == 'mdui' ? 'urn:oasis:names:tc:SAML:metadata:ui' : null),
      8,
    );
    const mdqLogo = mdqLogoElem.singleNodeValue.textContent;
    img.src = img.dataset['inCommon'] = mdqLogo;
  }

  handleSquishyImage($event: Event) {
    const img = $event.target as HTMLImageElement;
    if (img.width == 0) {
      if (img.naturalHeight > img.naturalWidth) img.height = 96;
      else img.width = 96;
    }
  }

  login(provider: string) {
    this.authService.beginLogin(provider);
  }
}
